import router from './router'
import store from './store'
import { getToken } from '@/utils/auth' // get token fro

const whiteList = ['/login', '/auth-redirect', '/register', '/forgetPassword', '/404', 'invitated'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  const isflash = store.getters.isflash
  if (!isflash) {
    next()
  } else {
    console.log('刷新页面')
    store.commit('user/SET_FALSH', false)
    await store.dispatch('user/getRobotConfig')
    await store.dispatch('user/getMenus')
    let hasToken = getToken()
    // 安心签
    if(localStorage.getItem('SIGN_TOKEN')) {
      await store.dispatch('sign/getUserInfo')
    }
    if(!!hasToken) {
      // await store.dispatch('user/getIdentity')
      await store.dispatch('user/getInfo')
      // await store.dispatch('user/getRoles')
      await store.dispatch('user/getCompanys')
      next({ ...to, replace: true })
    } else {
      if(to.path.indexOf('/back') == 0) {
        next({ path: '/' })
      } else {
        next({ ...to, replace: true })
      }
    }
  }
})